import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import store from '../store';
import {
    selectIsAshford,
    selectLocation,
    selectStorageSize,
    selectStorageType,
    setStorageSize,
    setStorageType,
} from '../store/bookingSlice';

import { ReactComponent as IconChevronLeft } from '../assets/icon-chevron-left.svg';

interface Props extends React.HTMLAttributes<HTMLElement> {
    desktop?: boolean;
    className?: string;
}

function BackLink(props: Props) {
    const windowLocation = useLocation();
    const location = useSelector(selectLocation);
    const navigate = useNavigate();
    const storageType = useSelector(selectStorageType);
    const storageSize = useSelector(selectStorageSize);
    const isAshford = useSelector(selectIsAshford);

    const goBack = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        if (!location) {
            navigate('/');
        }

        const slug = isAshford ? 'ashford' : location?.slug;

        if (windowLocation.pathname === '/booking') {
            navigate(`/locations/${slug}`);
        }

        if (windowLocation.pathname.match(/^\/locations\/[^/]+\/?$/)) {
            // If on step 1 'What are you storing for?', go back to /
            if (storageType === null) {
                navigate('/');
            }

            if (storageType !== null && storageSize !== null) {
                store.dispatch(setStorageSize(null));
            }

            // If on step 2 'How much space do you need?', go back to step 1
            if (storageType !== null && storageSize === null) {
                store.dispatch(setStorageType(null));
            }

            // If on step 3 'What are you storing?', go back to step 2
            if (storageType !== null && storageSize === 0) {
                store.dispatch(setStorageSize(null));
            }
        }

        if (windowLocation.pathname.match(/^\/locations\/[^/]+\/units\/?$/)) {
            store.dispatch(setStorageSize(null));
            store.dispatch(setStorageType(null));
            navigate(`/locations/${slug}`);
        }

        if (windowLocation.pathname.match(/^\/locations\/[^/]+\/booking\/?$/)) {
            navigate(`/locations/${slug}/units`);
        }

        if (windowLocation.pathname.match(/^\/locations\/[^/]+\/quote-sent\/?$/)) {
            navigate(`/locations/${slug}`);
        }
    };

    const linkProps = {
        className: `hidden-link ${props?.className || ''} ${
            windowLocation.pathname === '/' && 'invisible'
        }`,
    };

    const element = (
        <a href={'#'} {...linkProps} style={{ lineHeight: 1 }} onClick={goBack}>
            <IconChevronLeft height={16} aria-hidden />
        </a>
    );

    return element;
}

export default BackLink;
